/** @jsxImportSource @emotion/react */
import React from 'react'
import styled from '@emotion/styled'

import * as styles from './styles/index'
import Emoji30 from './emojis/30'
import Emoji90 from './emojis/90'
import Emoji150 from './emojis/150'
import Emoji210 from './emojis/210'
import Emoji270 from './emojis/270'
import Emoji330 from './emojis/330'

const angleToEmoji = {
  30: Emoji30,
  90: Emoji90,
  150: Emoji150,
  210: Emoji210,
  270: Emoji270,
  330: Emoji330,
}

type EmojiProps = {
  stripeWidthPercentage: number
  angle: number
}

const EmojiWrapper = styled.div((props: EmojiProps) => ({
  label: 'Emoji',
  position: 'absolute',
  width: `${props.stripeWidthPercentage / 2}%`,
  height: `${props.stripeWidthPercentage / 2}%`,
  top: `${props.stripeWidthPercentage / 4}%`,
  left: '46.5%',
  transform: `rotate(${-props.angle}deg)`,
}))

export type EmojiAngle = 30 | 90 | 150 | 210 | 270 | 330
type DialEmojiProps = {
  angle: EmojiAngle
  stripeWidthPercentage: number
}

export default function DialEmoji({ angle, stripeWidthPercentage }: DialEmojiProps) {
  const Emoji = angleToEmoji[angle]

  return (
    <div css={styles.rotator} style={{ transform: `rotate(${angle}deg)` }}>
      <EmojiWrapper stripeWidthPercentage={stripeWidthPercentage} angle={angle}>
        <Emoji />
      </EmojiWrapper>
    </div>
  )
}
